import React from 'react'

export let globalPaymentInputsRefs = {}

export const addPaymentInputRef = options => {
  const { paymentId } = options
  if (!globalPaymentInputsRefs[paymentId]) {
    const newRef = React.createRef()
    globalPaymentInputsRefs[paymentId] = newRef
    return newRef
  }
  return globalPaymentInputsRefs[paymentId]
}

export const getPaymentInputRef = options => {
  const { paymentId } = options
  return globalPaymentInputsRefs[paymentId] || null
}

export const clickPaymentInput = options => {
  const { paymentId } = options
  const ref = globalPaymentInputsRefs[paymentId]
  if (ref && ref.current) {
    ref.current.click()
    return true
  }
  return false
}

export const clearPaymentInputRefs = () => {
  globalPaymentInputsRefs = {}
}

export default globalPaymentInputsRefs
